// Copyright © 2021 The Things Industries B.V.

export default Object.freeze({
  DEFAULT_PORT: 196,
  DEFAULT_PACKAGE_NAME: 'azure-iot-hub',
})
